<template>
  <footer :class="{ hom, auto }" v-if="matricula">
    <div>
      <a href="#" :class="['btn btn-secondary', { free: prev }]" @click.prevent="toggle('prev')">Voltar</a>
    </div>
    <div>
      <a href="#" :class="['btn btn-primary', { free: canGoNext }]" @click.prevent="toggle('next')">{{ matricula.matricula.idSituacao == 1 ? '' : 'Salvar e ' }}Continuar</a>
    </div>
  </footer>
</template>

<script>
import AcademicoService from '@/services/academico.service'

export default {
  props: {
    prev: Boolean,
    next: Boolean,
    auto: Boolean
  },
  data () {
    return {
      hom: false,
      matricula: null,
      validarResponsavelFinanceiro: true,
      documentosObrigatoriosPendentes: null,
      loadingDocumentos: false
    }
  },
  computed: {
    responsavelFinanceiro () {
      if (this.matricula?.filiacao1?.responsavel?.financeiro == 1) {
        return this.matricula.filiacao1
      }

      if (this.filiacao2Ativa && this.matricula?.filiacao2?.responsavel?.financeiro == 1) {
        return this.matricula.filiacao2
      }

      return this.matricula?.responsavelFinanceiro
    },
    canGoNext () {
      return this.next &&
        this.canGoNextDocumentos &&
        this.canGoNextPlanoPagamento &&
        (
        !this.deveValidarResponsavelFinanceiro ||
        (
          !this.responsavelFinanceiro?.documento?.possuiRestricao &&
          this.responsavelFinanceiroContatosValidados
        )
      )
    },
    canGoNextPlanoPagamento () {
      return this.currentStep != 'planos-pagamento' ||
        this.hasPlanoPagamentoSelecionado
    },
    canGoNextDocumentos () {
      return this.currentStep != 'documentos' ||
        (
          !this.loadingDocumentos &&
          this.documentosObrigatoriosPendentes === 0
        )
    },
    hasPlanoPagamentoSelecionado () {
      return !!(
        this.matricula?.planoPagamento?.codigo ||
        this.matricula?.planoPag?.codigo ||
        this.matricula?.planoPag?.idprecificacao
      )
    },
    deveValidarResponsavelFinanceiro () {
      if ( !this.validarResponsavelFinanceiro ) return false

      if ( this.currentStep == 'filiacao' ) {
        return this.hasResponsavelFinanceiroNaFiliacao || this.hasResponsavelFinanceiroPreenchido
      }

      return this.currentStep == 'responsaveis'
    },
    currentStep () {
      return this.$route?.params?.step
    },
    filiacao2Ativa () {
      return !this.matricula?.semFiliacao2
    },
    hasResponsavelFinanceiroNaFiliacao () {
      return this.matricula?.filiacao1?.responsavel?.financeiro == 1 ||
        (this.filiacao2Ativa && this.matricula?.filiacao2?.responsavel?.financeiro == 1)
    },
    hasResponsavelFinanceiroPreenchido () {
      return !!(
        this.matricula?.responsavelFinanceiro?.Basicos?.idPessoa ||
        this.matricula?.responsavelFinanceiro?.documento?.cpf
      )
    },
    responsavelFinanceiroContatosValidados () {
      return this.isContatoValidado('email') &&
        this.isContatoValidado('telefonecelular')
    }
  },
  watch: {
    currentStep () {
      this.loadDocumentosObrigatorios()
    }
  },
  mounted () {
    this.hom = process.env.VUE_APP_ENV != 'PROD'

    this.$store.dispatch('matricula/get').then(response => {
      this.matricula = response
      // console.log('matricula on nav:', this.matricula)
      this.loadDocumentosObrigatorios()
    })

    window.addEventListener('documentosMatriculaUpdated', this.handleDocumentosUpdated)
  },
  beforeUnmount () {
    window.removeEventListener('documentosMatriculaUpdated', this.handleDocumentosUpdated)
  },
  methods: {
    handleDocumentosUpdated (event) {
      const idMatricula = event?.detail?.idMatricula

      if (!idMatricula || idMatricula == this.matricula?.matricula?.idMatricula) {
        this.loadDocumentosObrigatorios()
      }
    },
    loadDocumentosObrigatorios () {
      if (this.currentStep != 'documentos') return

      const idMatricula = this.matricula?.matricula?.idMatricula

      if (!idMatricula) {
        this.documentosObrigatoriosPendentes = null
        return
      }

      this.loadingDocumentos = true

      AcademicoService.getDocumentosByIdMatricula(idMatricula).then(response => {
        this.documentosObrigatoriosPendentes = this.countDocumentosObrigatoriosPendentes(response.data)
      })
      .catch(error => {
        console.error(error)
        this.documentosObrigatoriosPendentes = null
      })
      .finally(() => {
        this.loadingDocumentos = false
      })
    },
    countDocumentosObrigatoriosPendentes (documentos) {
      return ['docAluno', 'docResponsavel'].reduce((total, list) => {
        const items = documentos?.[list] || []

        return total + items.filter(documento => {
          return this.isDocumentoRequerido(documento) &&
            this.isDocumentoObrigatorio(documento) &&
            !this.hasDocumentoEntregue(documento)
        }).length
      }, 0)
    },
    isDocumentoRequerido (documento) {
      return this.auto
        ? documento?.requeridoPortal == 1
        : documento?.requeridoGestao == 1
    },
    isDocumentoObrigatorio (documento) {
      return documento?.obrigatorio == 1 || documento?.obrigatorio === true
    },
    hasDocumentoEntregue (documento) {
      const entregue = documento?.documentoEntregue || {}

      return !!(
        entregue.iddocumentoEntregue ||
        entregue.idClickSign ||
        entregue.envelopeId ||
        entregue.urldocumento
      )
    },
    isContatoValidado ( type ) {
      const basicos = this.responsavelFinanceiro?.Basicos || {}
      const fields = type == 'email'
        ? ['emailVerificado', 'emailValidado', 'email_validated_at']
        : ['telefonecelularVerificado', 'telefoneCelularVerificado', 'celularVerificado', 'telefoneValidado', 'celular_validated_at']

      return fields.some(field => {
        if ( field == 'email_validated_at' || field == 'celular_validated_at' ) {
          return !!String(basicos[field] || '').trim()
        }

        return basicos[field] == 1 || basicos[field] === true
      })
    },
    toggle ( dir ) {
      if (dir == 'next' && !this.canGoNext) return

      this.$emit(dir)
    }
  }
}
</script>

<style lang="scss" scoped>
  footer {
    border-top: $border-component;
    width: calc(100% - 60px);
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: $color-secondary;
    padding: $hmg_mid;
    position: fixed; bottom: 0; z-index: 1000;

    &.hom {
      bottom: 21px;
      border-bottom-left-radius: 6px;
    }

    &.auto {
      bottom: 0;
      width: 100%;
    }

    a {
      &:not(.free) {
        pointer-events: none;
        opacity: .5;
      }
    }
  }
</style>
